import { render, staticRenderFns } from "./viewCompletework.vue?vue&type=template&id=0b503cde&scoped=true"
import script from "./viewCompletework.vue?vue&type=script&lang=js"
export * from "./viewCompletework.vue?vue&type=script&lang=js"
import style0 from "./viewCompletework.vue?vue&type=style&index=0&id=0b503cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b503cde",
  null
  
)

export default component.exports